( function () {
	const nav = document.querySelector( '[data-navbar]' );
	if ( ! nav ) return;

	const burger = nav.querySelector( '.nav__burger' );
	const navmob = nav.querySelector( '.navmob' );

	// ---- sticky/scrolled state (toggle >40px, 1:1 z exportu) ----
	const onScroll = () => {
		nav.classList.toggle( 'is-scrolled', window.scrollY > 40 );
	};
	onScroll();
	window.addEventListener( 'scroll', onScroll, { passive: true } );

	if ( ! burger || ! navmob ) return;

	const setOpen = ( open ) => {
		burger.classList.toggle( 'is-open', open );
		navmob.classList.toggle( 'is-open', open );
		burger.setAttribute( 'aria-expanded', String( open ) );
	};

	burger.addEventListener( 'click', () => {
		setOpen( ! burger.classList.contains( 'is-open' ) );
	} );

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' ) setOpen( false );
	} );

	navmob.querySelectorAll( 'a' ).forEach( ( a ) => {
		a.addEventListener( 'click', () => setOpen( false ) );
	} );
} )();
